// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1FMaq","footer":"ModalFilter_footer__8fMFl"};